function contentPublishWindowService(moment) {
  const service = {};

  service.getDataBuckets = (bucketsConfig, data) => {
    const dataBuckets = new Array(bucketsConfig.length).fill(0);

    data.forEach((d) => {
      const h = moment(d[0]).get('hour');
      const storyCount = d[1];

      bucketsConfig.forEach((date, index) => {
        if (h >= date.startHour && h < date.endHour) {
          dataBuckets[index] += storyCount;
        }
      });
    });

    return dataBuckets;
  };

  service.calculateNotLiveBars = (inputDate, dateToday, notLive, bucketsConfig) => {
    const notLiveData = notLive;
    const hourNow = moment().get('hour');
    let numOfBars;

    /** empty the data for not live bars to avoid rendering, when the date selected is other than
     *  today
     */
    if (inputDate < dateToday) {
      notLiveData.forEach((d, i) => {
        notLiveData[i] = 0;
      });
      return notLiveData;
    }
    /* Otherwise if the date selected is for today, then calculate the number of not
       live bars to be rendered for the rest of the day */
    for (let i = 0; i < bucketsConfig.length; i += 1) {
      if (hourNow >= bucketsConfig[i].startHour && hourNow < bucketsConfig[i].endHour) {
        numOfBars = notLiveData.length - i;
        break;
      }
    }
    // Above calculation determines the number of not live bars to be rendered

    // Number of not live bars NOT to be rendered
    const noBars = notLiveData.length - numOfBars;

    // put the 0 in data for all of the notLiveBars that don't need to be rendered
    for (let i = 0; i < noBars; i += 1) {
      notLiveData[i] = 0;
    }

    return notLiveData;
  };

  service.getStoryCountOutOfPercentage = (percent, totalCount) =>
    Math.round((percent / 100) * totalCount);

  // Extract the attributes of already rendered rects, given that proper nodes are provided
  // Returned data is used to perform animations
  service.getPrevRectAttr = (prevRectNode) => {
    const prevRectData = [];
    if (prevRectNode && prevRectNode.length !== 0) {
      prevRectNode.forEach((value, index) => {
        prevRectData[index] = {};
        prevRectData[index].height = Number(value.attributes.height.nodeValue);
        prevRectData[index].y = Number(value.attributes.y.nodeValue);
      });
    }

    return prevRectData;
  };

  return service;
}

const service = [
  'moment',
  contentPublishWindowService
];

module.exports = (ngModule) => {
  ngModule.service('contentPublishWindowService', service);
};
